export default __webpack_public_path__ + "static/media/background.ff43adfd.png";